import script from "./GroupsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupsPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__